import HTTP from 'Utils/HTTP';
import List from 'list.js';

class JobsWidget {
	filterOptions = {
		categories: 'none',
		targetGroups: 'none',
		locations: 'none',
	};

	selects = {};
	filterCounts = {};

	constructor(el) {
		this.root = el;

		this.onSelectChange = ::this.onSelectChange;

		this.link = this.root.querySelector('.js-josbWidgetLink');
		this.url = this.link.dataset.url;

		Array.from(this.root.querySelectorAll('.js-jobsWidgetSelect')).forEach(el => {
			this.selects[el.name] = el;
			this.selects[el.name].addEventListener('change', this.onSelectChange);
		});

		this.jobsList = this.root.querySelector('.js-jobsList');
		this.jobsListCount = this.root.querySelector('.js-jobsWidgetCount');

		this.loadData();
		this.initJobsList();
	}

	loadData() {
		const url = this.root.dataset.filterDataUrl;
		HTTP.get(url).then(res => {
			this.filterData = res.data.filterData;
			this.fillSelects();
			this.applyFilterOptions();
		});
	}

	initJobsList() {
		const options = {
			valueNames: [{ data: ['categories', 'locations', 'targetGroups'] }],
		};

		this.jobsList = new List(this.jobsList, options);
		this.jobsList.on('filterComplete', ::this.onFilterComplete);
	}

	fillSelects() {
		const filterData = this.filterData;

		for (const key in this.selects) {
			if (Object.hasOwnProperty.call(this.selects, key)) {
				const selectData = filterData[key];
				selectData.forEach(item => {
					const option = document.createElement('option');
					option.innerHTML = item.name;
					option.value = item.internalName || item.id;
					this.selects[key].append(option);
				});
			}
		}
	}

	onSelectChange(e) {
		const { value, name } = e.currentTarget;
		this.filterOptions[name] = value;

		this.applyFilterOptions();
	}

	applyFilterOptions() {
		console.log(this.filterOptions);
		this.jobsList.filter(item => {
			const filtered = {};

			for (const filterKey in this.filterOptions) {
				filtered[filterKey] = false;
				const itemFilterValue = item.values()[filterKey].split('|');
				if (Object.hasOwnProperty.call(this.filterOptions, filterKey)) {
					const filterOptionValue = this.filterOptions[filterKey];
					filtered[filterKey] =
						itemFilterValue.includes(filterOptionValue) || filterOptionValue === 'none';
				}
			}

			let isFiltered = true;
			for (const filteredKey in filtered) {
				if (Object.hasOwnProperty.call(filtered, filteredKey)) {
					const filterState = filtered[filteredKey];
					if (!filterState) isFiltered = false;
				}
			}

			return isFiltered;
		});
	}

	onFilterComplete(e) {
		this.updateJobsCountDisplay();
	}

	updateJobsCountDisplay() {
		if (this.jobsList.matchingItems.length === 0) {
			this.link.classList.add('is-disabled');
		} else {
			this.link.classList.remove('is-disabled');
		}

		this.link.href = `${this.url}?categories=${this.filterOptions.categories}&locations=${this.filterOptions.locations}&targetGroups=${this.filterOptions.targetGroups}`;
		this.jobsListCount.innerText = this.jobsList.matchingItems.length;
	}
}

Array.from(document.querySelectorAll('.js-jobsWidget')).forEach(el => new JobsWidget(el));
